export * from './areaCode'
export * from './api'
export * from './c2c'
export * from './scene'
export * from './wallet'
export * from './agent'

export enum UserRole {
  /** 普通用户 */
  User = 0,
  /** 商家 */
  Agent = 1,
  /** 商户会员 */
  MerchantMember = 2,
}
